import {Injectable} from '@angular/core';
import {Http} from "@angular/http";
import {WindowRef} from "./window-ref";

@Injectable()
export class VersionCheckService {

    get currentHash(): string {
        return this._currentHash;
    }

    set currentHash(value: string) {
        this._currentHash = value;
    }
    // this will be replaced by actual hash post-build.js
    private _currentHash = '{{POST_BUILD_ENTERS_HASH_HERE}}';

    constructor(private http: Http, private window:WindowRef) {}

    /**
     * Checks in every set frequency the version of frontend application
     * @param url
     * @param {number} frequency - in milliseconds, defaults to 30 minutes
     */
    public initVersionCheck(url, frequency =  cacheBuster) {
        return setInterval(() => {
            // console.log("Checking version with cacheBuster: " + cacheBuster);
            this.checkVersion(url);
        }, frequency);
    }

    /**
     * Will do the call and check if the hash has changed or not
     * @param url
     */
    private checkVersion(url) {
        // timestamp these requests to invalidate caches
        this.http.get(url + '?t=' + new Date().getTime())
            .first()
            .subscribe(
                (response: any) => {
                    const hash = JSON.parse(response._body)['version'];
                    const hashChanged = this.hasHashChanged(this._currentHash, hash);

                    // If new version, do something
                    if (hashChanged) {
                        // console.log("Reloading...");
                        this.reloading();
                    }
                    // store the new hash so we wouldn't trigger versionChange again
                    // only necessary in case you did not force refresh
                    this._currentHash = hash;
                },
                (err) => {
                    console.error(err, 'Could not get version');
                }
            );
    }

    public reloading() {
        this.window.nativeWindow.location.reload(true);
    }

    getCurrentHash(){
        return this._currentHash;
    }

    /**
     * Checks if hash has changed.
     * This file has the JS hash, if it is a different one than in the version.json
     * we are dealing with version change
     * @param currentHash
     * @param newHash
     * @returns {boolean}
     */
    private hasHashChanged(currentHash, newHash) {
        if (!currentHash || currentHash === '{{POST_BUILD_ENTERS_HASH_HERE}}') {
            return false;
        }

        return currentHash !== newHash;
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/core/version-check.service.ts